import { Page, Text, View } from "@react-pdf/renderer";

import {
  getClinicAddress,
  getCrmParts,
  getMedFields,
  getPatientCpf,
  getPatientName,
  getPrescritorNome,
  NotificationDigitalFooter,
  NotificationStripe,
  notificationStyles as s,
  RECEITA_STRIPE,
  type NotificationPdfProps,
} from "./notificationShared";

export function NotificationReceitaTalidomida({
  filterSpecialMedication,
  dataPdf,
  linkDocument,
  qrCodeDataUrl,
  qrCodeSncrDataUrl,
  sncrConsultaUrl,
}: NotificationPdfProps) {
  const item = filterSpecialMedication?.[0];
  const med = getMedFields(item);
  const { crm, uf } = getCrmParts(dataPdf);
  const address = getClinicAddress(dataPdf);

  return (
    <Page size="A4" style={s.page}>
      <NotificationStripe color={RECEITA_STRIPE.NRT} />

      <View style={s.headerRow}>
        <View style={s.titleBlock}>
          <Text style={s.titleMain}>NOTIFICAÇÃO DE RECEITA DE</Text>
          <Text style={[s.eletronica, { letterSpacing: 0.5, fontSize: 12 }]}>
            TALIDOMIDA
          </Text>
          <Text style={s.eletronica}>ELETRÔNICA</Text>
        </View>
        <View style={s.numeroWrap}>
          <Text style={s.numeroLabel}>N.º</Text>
          <Text style={s.numeroValue}>{med.sncrNumero || ""}</Text>
        </View>
      </View>

      <View style={s.warningBox}>
        <Text style={s.warningText}>
          ATENÇÃO — Proibida para mulheres grávidas ou com chance de engravidar
        </Text>
        <Text style={s.warningText}>
          Talidomida causa o nascimento de crianças sem braços e sem pernas
        </Text>
      </View>

      <View style={s.twoCol}>
        <View style={s.col}>
          <View style={s.colHeader}>
            <Text style={s.colTitle}>Emitente</Text>
          </View>
          <View style={s.colBody}>
            <Text style={s.field}>
              Nome do médico:{" "}
              <Text style={s.value}>{getPrescritorNome(dataPdf)}</Text>
            </Text>
            <Text style={s.field}>
              CPF: <Text style={s.value}></Text>
            </Text>
            <Text style={s.field}>
              Inscrição no CRM / UF:{" "}
              <Text style={s.value}>
                {crm && uf ? `${crm} / ${uf}` : ""}
              </Text>
            </Text>
            <Text style={s.field}>
              N.º do cadastro: <Text style={s.value}></Text>
            </Text>
            <Text style={s.field}>
              Especialidade: <Text style={s.value}></Text>
            </Text>
            <Text style={s.field}>
              Endereço completo: <Text style={s.value}>{address}</Text>
            </Text>
            <Text style={s.field}>
              Telefone: <Text style={s.value}></Text>
            </Text>
          </View>
        </View>
        <View style={s.col}>
          <View style={s.colHeader}>
            <Text style={s.colTitle}>Paciente</Text>
          </View>
          <View style={s.colBody}>
            <Text style={s.field}>
              Nome: <Text style={s.value}>{getPatientName(dataPdf)}</Text>
            </Text>
            <Text style={s.field}>
              CPF ou, se estrangeiro, passaporte:{" "}
              <Text style={s.value}>{getPatientCpf(dataPdf)}</Text>
            </Text>
            <Text style={s.field}>
              Endereço completo: <Text style={s.value}></Text>
            </Text>
            <Text style={s.field}>
              Data de nascimento: <Text style={s.value}></Text>
            </Text>
            <Text style={s.field}>
              Sexo: <Text style={s.value}></Text>
            </Text>
            <Text style={s.field}>
              CID: <Text style={s.value}></Text>
            </Text>
            <Text style={s.field}>
              Telefone (se houver): <Text style={s.value}></Text>
            </Text>
          </View>
        </View>
      </View>

      <View style={[s.col, { marginBottom: 8 }]}>
        <View style={s.colHeader}>
          <Text style={s.colTitle}>
            Identificação do responsável pelo paciente (se for o caso)
          </Text>
        </View>
        <View style={s.colBody}>
          <Text style={s.field}>
            Nome: <Text style={s.value}></Text>
          </Text>
          <Text style={s.field}>
            CPF ou, se estrangeiro, passaporte: <Text style={s.value}></Text>
          </Text>
          <Text style={s.field}>
            Endereço completo: <Text style={s.value}></Text>
          </Text>
          <Text style={s.field}>
            Telefone (se houver): <Text style={s.value}></Text>
          </Text>
        </View>
      </View>

      <View style={[s.prescriptionBox, { minHeight: 150 }]}>
        <View style={s.prescriptionHeader}>
          <Text style={s.prescriptionTitle}>Prescrição</Text>
        </View>
        <View style={s.prescriptionBody}>
          <Text style={s.fieldSpaced}>
            Quantidade de comprimidos (em algarismos arábicos e por extenso):{" "}
            <Text style={s.value}>{med.quantidade}</Text>
          </Text>
          <Text style={s.fieldSpaced}>
            Dose por unidade posológica:{" "}
            <Text style={s.value}>{med.concentracao}</Text>
          </Text>
          <Text style={s.fieldSpaced}>
            Posologia: <Text style={s.value}>{med.posologia}</Text>
          </Text>
          <Text style={s.fieldSpaced}>
            Tempo de tratamento: <Text style={s.value}></Text>
          </Text>
          <Text style={s.fieldSpaced}>
            Outras orientações (se houver):{" "}
            <Text style={s.value}>{med.note}</Text>
          </Text>
          <Text style={s.fieldSpaced}>
            Medicamento: <Text style={s.value}>{med.nome}</Text>
          </Text>
        </View>
      </View>

      <NotificationDigitalFooter
        linkDocument={linkDocument}
        qrCodeDataUrl={qrCodeDataUrl}
        qrCodeSncrDataUrl={qrCodeSncrDataUrl}
        sncrConsultaUrl={sncrConsultaUrl}
      />
    </Page>
  );
}
